import { createGlobalStyle } from 'styled-components';

import '../../assets/fonts/fonts.css';

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }

  html {
    font-size: 62.5%; //1 rem = 10px; 10px/16px = 62.5%
    overflow: ${({ lockScroll }) => lockScroll && 'hidden'};
  }

  body, button {
    box-sizing: border-box;
    font-family: Archia, sans-serif;
    font-weight: 400;
  }
`;
